import { render, staticRenderFns } from "./WealthPlanning.vue?vue&type=template&id=77acb4ef&scoped=true&"
import script from "./WealthPlanning.vue?vue&type=script&lang=js&"
export * from "./WealthPlanning.vue?vue&type=script&lang=js&"
import style0 from "./WealthPlanning.vue?vue&type=style&index=0&id=77acb4ef&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77acb4ef",
  null
  
)

export default component.exports